import { action } from 'typesafe-actions';
import { UserSpecificSettings, SettingsActionTypes } from './types';

export const saveUserSettings = (userKey: string, userSettings: UserSpecificSettings) =>
  action(SettingsActionTypes.SAVE_USER_SETTINGS, { userKey, userSettings });
